// extracted by mini-css-extract-plugin
export default {"editButton":"UpdateBook_editButton__wWH5E"};